<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Penerimaan - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Penerimaan - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Keuangan / Transaksi / Penerimaan / Edit</span
        >
        <span v-else class="font-small"
          >/ Keuangan / Transaksi / Penerimaan / Tambah</span
        >
      </div>
    </div>
    <form-penerimaan :id="id" />
  </div>
</template>

<script>
import FormPenerimaan from '@/components/keuangan/FormPenerimaan'

export default {
  components: {
    FormPenerimaan,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
